import React from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Input, InputNumber, Row, Select } from 'antd';

export default function TripInformation({ Form }) {
	return (
		<Form.List name='tripInformation'>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name }) => (
						<Row gutter={[16, 0]} key={key}>
							<Col sm={24} md={6}>
								<Form.Item label='Accommodation' name={[name, 'accommodation']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='No Stay, 1 Star , 2 Star , 3 Star ,etc.'
										options={[
											{ label: 'No Stay', value: 'No Stay' },
											{ label: '1 Star ', value: '1 Star' },
											{ label: '2 Star ', value: '2 Star' },
											{ label: '3 Star ', value: '3 Star' },
											{ label: '4 Star', value: '4 Star' },
											{ label: '5 Star', value: '5 Star' },
											{ label: 'Home Stay', value: 'Home Stay' },
											{ label: 'Group Stay', value: 'Group Stay' },
											{ label: 'Tent Stay', value: 'Tent Stay' },
											{ label: 'Cottage Stay', value: 'Cottage Stay' },
										]}
									/>
								</Form.Item>
							</Col>
							<Col sm={24} md={8}>
								<Form.Item label='Trek/Tour Difficulty' name={[name, 'touravailability']}>
									<Input placeholder='e.g. Easy, Moderate, Difficult' />
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Trip Guide' name={[name, 'tripguide']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Guided, No Guide etc.'
										options={[
											{ label: 'Guided', value: 'Guided' },
											{ label: 'No Guide', value: 'No Guide' },
											{ label: 'Self Exploring', value: 'Self Exploring' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Payment Method' name={[name, 'paymentmethod']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='UPI, Debit Card etc.'
										options={[
											{ label: 'UPI', value: 'UPI' },
											{ label: 'Debit Card', value: 'Debit Card' },
											{ label: 'Credit Card', value: 'Credit Card' },
											{ label: 'Cash', value: 'Cash' },
											{ label: 'Bank Transfer', value: 'Bank Transfer' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Transport Mode' name={[name, 'itineraryTransportMode1']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Bike, Car, Bus, Railway, Flight, Ferry etc.'
										options={[
											{ label: 'Bike', value: 'Bike' },
											{ label: 'Car', value: 'Car' },
											{ label: 'Bus', value: 'Bus' },
											{ label: 'Railway', value: 'Railway' },
											{ label: 'Flight', value: 'Flight' },
											{ label: 'Ferry', value: 'Ferry' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Activities' name={[name, 'activities']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Trekking, Rappelling etc.'
										options={[
											{ label: 'Trekking', value: 'Trekking' },
											{ label: 'Rappelling', value: 'Rappelling' },
											{ label: 'Hiking', value: 'Hiking' },
											{ label: 'River Crossing', value: 'River Crossing' },
											{ label: 'Camping', value: 'Camping' },
											{ label: 'Stargazing', value: 'Stargazing' },
											{ label: 'Rock Climbing', value: 'Rock Climbing' },
											{ label: 'Beach Explorations', value: 'Beach Explorations' },
											{ label: 'Mountain biking', value: 'Mountain biking' },
											{ label: 'Cycling', value: 'Cycling' },
											{ label: 'Kayaking or canoeing', value: 'Kayaking or canoeing' },
											{ label: 'Paragliding', value: 'Paragliding' },
											{ label: 'Backpacking', value: 'Backpacking' },
											{ label: 'Zip-lining', value: 'Zip-lining' },
											{ label: 'Trail Running', value: 'Trail Running' },
											{ label: 'Scuba diving or snorkeling', value: 'Scuba diving or snorkeling' },
											{ label: 'Wildlife watching / birding', value: 'Wildlife watching / birding' },
											{ label: 'BBQ', value: 'BBQ' },
											{ label: 'Playing lawn games', value: 'Playing lawn games' },
											{ label: 'Visiting a local park, zoo, or botanical garden', value: 'Visiting a local park, zoo, or botanical garden' },
											{ label: 'Attending outdoors concerts, markets, or festivals', value: 'Attending outdoors concerts, markets, or festivals' },
											{ label: 'Temple Explorations', value: 'Temple Explorations' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Group Size' name={[name, 'groupsize']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='1-10, 1-20 etc.'
										options={[
											{ label: '1-10', value: '1-10' },
											{ label: '1-20', value: '1-20' },
											{ label: '1-30', value: '1-30' },
											{ label: '1-40', value: '1-40' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Trip Type' name={[name, 'triptype']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Camping Trip, Hiking/Backpacking Trip, National Park Trip  etc.'
										options={[
											{ label: 'Camping Trip', value: 'Camping Trip' },
											{ label: 'Hiking/Backpacking Trip', value: 'Hiking/Backpacking Trip' },
											{ label: 'National Park Trip', value: 'National Park Trip' },
											{ label: 'Eco-tourism', value: 'Eco-tourism' },
											{ label: 'Historical Tour', value: 'Historical Tour' },
											{ label: 'Road Trip', value: 'Road Trip' },
											{ label: 'Safari or Wildlife Trip', value: 'Safari or Wildlife Trip' },
											{ label: 'Trekking', value: 'Trekking' },
											{ label: 'Trekking Expedition', value: 'Trekking Expedition' },
											{ label: 'Family Friendly', value: 'Family Friendly' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Age Group' name={[name, 'agegroup']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='1-60, 5-40 etc.'
										options={[
											{ label: '1-60', value: '1-60' },
											{ label: '5-40', value: '5-40' },
											{ label: '5-50', value: '5-50' },
											{ label: '5-60', value: '5-60' },
											{ label: '5-70', value: '5-70' },
											{ label: '10-40', value: '10-40' },
											{ label: '15-40', value: '15-40' },
											{ label: '15-50', value: '15-50' },
											{ label: '10-50', value: '10-50' },
											{ label: 'Open For All', value: 'Open For All' },
										]}
									/>
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Free Cancel' name={[name, 'freecancel']}>
									<Select allowClear showArrow mode='multiple' style={{ width: '100%' }} placeholder='Yes  etc.' options={[{ label: 'As Per Cancellation Policy', value: 'As Per Cancellation Policy' }]} />
								</Form.Item>
							</Col>

							<Col sm={24} md={6}>
								<Form.Item label='Insurance' name={[name, 'insurance']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Include, Not Include, Not Applicable  etc.'
										options={[
											{ label: 'Include', value: 'Include' },
											{ label: 'Not Include', value: 'Not Include' },
											{ label: 'Not Applicable', value: 'Not Applicable' },
										]}
									/>
								</Form.Item>
							</Col>
							<Col sm={24} md={6}>
								<Form.Item label='Departure City' name={[name, 'departurecity']}>
									<Input placeholder='e.g. Nepal' />
								</Form.Item>
							</Col>

							<Col sm={24} md={1}>
								{fields.length > 1 && (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								)}
							</Col>
							<Divider style={{ margin: 0, marginBottom: 16 }} />
						</Row>
					))}
					<Row gutter={[16, 0]}>
						<Col sm={24} md={6}>
							<Form.Item>
								<Button icon={<PlusOutlined />} type='primary' onClick={() => add()} style={{ width: '100%' }}>
									Add Trip
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}
		</Form.List>
	);
}
